import { TripEventModelWithTask } from '@/models/trip/TripEventModelWithTask';
import { StationPassage } from '@/models/trip/concrete-trip-task/StationPassage';
import { Type } from 'class-transformer';

export class StationPassageEventModel extends TripEventModelWithTask {
  @Type(() => StationPassage)
  public tripTask!: StationPassage;
}
